import React, { ButtonHTMLAttributes } from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import Button from '../../button/button';

import styles from './infinite-pagination.module.scss';

interface Props {
	className?: string;
	from: number;
	to: number;
	hasBack: boolean;
	hasNext: boolean;
	total?: number;
	onBackClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
	onNextClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
	['data-test-id']?: string;
}

const InfinitePagination = ({
	'data-test-id': dataTestId,
	className,
	from,
	to,
	total,
	hasBack,
	hasNext,
	onBackClick,
	onNextClick
}: Props) => {
	return (
		<nav data-test-id={dataTestId} className={className}>
			<Button
				icon={<BringgIcon iconName={BringgFontIcons.ChevronLeft} className={styles.navigationButtonIcon} />}
				type="link"
				disabled={!hasBack}
				className={styles.navigationButton}
				aria-label="back"
				onClick={onBackClick}
			/>

			<span>
				{from} - {to}
			</span>

			<Button
				icon={<BringgIcon iconName={BringgFontIcons.ChevronRight} className={styles.navigationButtonIcon} />}
				type="link"
				disabled={!hasNext}
				className={styles.navigationButton}
				aria-label="next"
				onClick={onNextClick}
			/>

			<span>{total === undefined ? 'Many' : total}</span>
		</nav>
	);
};

export default InfinitePagination;
